import { Component, OnInit, Input } from '@angular/core';
import { LatLngBounds } from '@agm/core';
import { Router } from '@angular/router';
declare const google;

@Component({
  selector: 'google-map',
  templateUrl: './google-map.component.html',
  styleUrls: ['./google-map.component.scss']
})
export class GoogleMapComponent implements OnInit {
  markers = [];
  isMarksReady: boolean = false;
  mapHeight = `300px`;
  mapControlPosition = `LEFT_TOP`;
  pin;
  pinColors = {
    default: {
      pinEnd: '#F3443B',
      pinStart: '#FB7467',
      pinStroke: '#B73830',
      circle: '#5C1410'
    },
    viewed: {
      pinEnd: '#10CFBD',
      pinStart: '#2BECDA',
      pinStroke: '#17C9B8',
      circle: '#FFF'
    }
  };
  selectedInfoWindow;
  openedInfoWindow;
  mapDefaults: { [key: string]: any } = {};
  isForPropertyDetails;

  @Input()
  set PropertyLocations(data) {
    this.markers = data || [];
    this.initPin();
    this.setDefaultPin(this.markers);
  }

  @Input()
  set MapControlPosition(position) {
    this.mapControlPosition = position;
  }

  @Input()
  set MapHeight(height) {
    this.mapHeight = height;
  }

  @Input()
  set IsForPropertyDetails(val) {
    this.isForPropertyDetails = val;
    this.setDefaultPin(this.markers);
  }

  googleMapStyles = [
    {
      featureType: 'water',
      elementType: 'all',
      stylers: [
        {
          hue: '#e9ebed'
        },
        {
          saturation: -78
        },
        {
          lightness: 67
        },
        {
          visibility: 'simplified'
        }
      ]
    },
    {
      featureType: 'landscape',
      elementType: 'all',
      stylers: [
        {
          hue: '#ffffff'
        },
        {
          saturation: -100
        },
        {
          lightness: 100
        },
        {
          visibility: 'simplified'
        }
      ]
    },
    {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [
        {
          hue: '#bbc0c4'
        },
        {
          saturation: -93
        },
        {
          lightness: 31
        },
        {
          visibility: 'simplified'
        }
      ]
    },
    {
      featureType: 'poi',
      elementType: 'all',
      stylers: [
        {
          hue: '#ffffff'
        },
        {
          saturation: -100
        },
        {
          lightness: 100
        },
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'road.local',
      elementType: 'geometry',
      stylers: [
        {
          hue: '#e9ebed'
        },
        {
          saturation: -90
        },
        {
          lightness: -8
        },
        {
          visibility: 'simplified'
        }
      ]
    },
    {
      featureType: 'transit',
      elementType: 'all',
      stylers: [
        {
          hue: '#e9ebed'
        },
        {
          saturation: 10
        },
        {
          lightness: 69
        },
        {
          visibility: 'on'
        }
      ]
    },
    {
      featureType: 'administrative.locality',
      elementType: 'all',
      stylers: [
        {
          hue: '#2c2e33'
        },
        {
          saturation: 7
        },
        {
          lightness: 19
        },
        {
          visibility: 'on'
        }
      ]
    },
    {
      featureType: 'road',
      elementType: 'labels',
      stylers: [
        {
          hue: '#bbc0c4'
        },
        {
          saturation: -93
        },
        {
          lightness: 31
        },
        {
          visibility: 'on'
        }
      ]
    },
    {
      featureType: 'road.arterial',
      elementType: 'labels',
      stylers: [
        {
          hue: '#bbc0c4'
        },
        {
          saturation: -93
        },
        {
          lightness: -2
        },
        {
          visibility: 'simplified'
        }
      ]
    }
  ];

  constructor(private router: Router) {}

  ngOnInit() {}

  onMapReady(map) {
    this.mapDefaults = {
      streetViewControl: false,
      zoomControl: false
    };
    if (this.markers.length === 1) {
      if (this.isForPropertyDetails) {
        this.mapDefaults.zoom = 12;
        this.mapDefaults.center = new google.maps.LatLng(
          this.markers[0].locationLatitude,
          this.markers[0].locationLongitude
        );
      } else {
        this.mapDefaults.zoom = 5;
        this.mapDefaults.center = new google.maps.LatLng(21.941646, -78.646431);
      }
    } else {
      /* google.maps.event.addListenerOnce(map, 'zoom_changed', function() {
         map.setZoom(map.getZoom() - 1);
       });
       map.fitBounds(this.findPropertiesBounds(this.markers)); */

      /*Dont delete above*/
      this.mapDefaults.zoom = 5;
      this.mapDefaults.center = new google.maps.LatLng(21.941646, -78.646431);
    }
    map.setOptions(this.mapDefaults);

    map.controls[google.maps.ControlPosition[this.mapControlPosition]].push(
      this.customMyLocationControl(map)
    );
    map.controls[google.maps.ControlPosition[this.mapControlPosition]].push(
      this.customZoomControl(map)
    );
  }

  findPropertiesBounds(markers) {
    const bounds: LatLngBounds = new google.maps.LatLngBounds();
    if (markers.length < 2) {
      bounds.extend(
        new google.maps.LatLng(
          this.markers[0].locationLatitude,
          this.markers[0].locationLongitude
        )
      );
    } else {
      for (const marker of markers) {
        bounds.extend(
          new google.maps.LatLng(
            marker.locationLatitude,
            marker.locationLongitude
          )
        );
      }
    }
    return bounds;
  }

  customZoomControl(map) {
    const zoomControlDiv = document.createElement('div');
    zoomControlDiv.style.padding = '0px 10px 5px';

    const zoomControlWrapper = document.createElement('div');
    zoomControlWrapper.style.backgroundColor = '#10CFBD';
    zoomControlWrapper.style.borderRadius = '3px';
    zoomControlWrapper.style.cursor = 'pointer';
    zoomControlWrapper.style.width = '30px';
    zoomControlWrapper.style.overflow = 'hidden';
    zoomControlWrapper.style.boxShadow = '1px 1px 5px 0px lightgrey';
    zoomControlDiv.appendChild(zoomControlWrapper);

    const zoomInButton = document.createElement('div');
    zoomInButton.style.width = '100%';
    zoomInButton.style.height = '32px';
    zoomInButton.style.display = 'flex';
    zoomInButton.style.alignItems = 'center';
    zoomInButton.style.justifyContent = 'center';
    zoomInButton.style.fontSize = '14px';
    zoomInButton.style.color = 'white';

    const zoomInButtonIcon = document.createElement('i');
    zoomInButtonIcon.className = 'fa fa-plus';
    zoomInButton.appendChild(zoomInButtonIcon);
    zoomControlWrapper.appendChild(zoomInButton);

    const horizontalDivider = document.createElement('div');
    horizontalDivider.style.borderBottom = '1px solid white';
    horizontalDivider.style.width = '70%';
    horizontalDivider.style.borderRadius = '50px';
    horizontalDivider.style.margin = '0 15%';
    zoomControlWrapper.appendChild(horizontalDivider);

    const zoomOutButton = document.createElement('div');
    zoomOutButton.style.width = '100%';
    zoomOutButton.style.height = '32px';
    zoomOutButton.style.display = 'flex';
    zoomOutButton.style.alignItems = 'center';
    zoomOutButton.style.justifyContent = 'center';
    zoomOutButton.style.fontSize = '14px';
    zoomOutButton.style.color = 'white';

    const zoomOutButtonIcon = document.createElement('i');
    zoomOutButtonIcon.className = 'fa fa-minus';
    zoomOutButton.appendChild(zoomOutButtonIcon);
    zoomControlWrapper.appendChild(zoomOutButton);

    google.maps.event.addDomListener(zoomInButton, 'click', function() {
      map.setZoom(map.getZoom() + 1);
    });
    google.maps.event.addDomListener(zoomOutButton, 'click', function() {
      map.setZoom(map.getZoom() - 1);
    });

    return zoomControlDiv;
  }

  customMyLocationControl(map) {
    const myLocationControlDiv = document.createElement('div');

    const firstChild = document.createElement('button');
    firstChild.style.backgroundColor = '#fff';
    firstChild.style.border = 'none';
    firstChild.style.outline = 'none';
    firstChild.style.width = '30px';
    firstChild.style.height = '30px';
    firstChild.style.borderRadius = '2px';
    firstChild.style.boxShadow = '1px 1px 5px 0px lightgrey';
    firstChild.style.cursor = 'pointer';
    firstChild.style.margin = '5px 10px 0px';
    firstChild.style.padding = '0';
    firstChild.title = 'Your Location';
    myLocationControlDiv.appendChild(firstChild);

    const secondChild = document.createElement('div');
    secondChild.style.margin = '5px 5px 5px 6px';
    secondChild.style.width = '18px';
    secondChild.style.height = '18px';
    secondChild.style.backgroundImage =
      'url(https://maps.gstatic.com/tactile/mylocation/mylocation-sprite-2x.png)';
    secondChild.style.backgroundSize = '180px 18px';
    secondChild.style.backgroundPosition = '0 0';
    secondChild.style.backgroundRepeat = 'no-repeat';
    firstChild.appendChild(secondChild);

    google.maps.event.addListener(map, 'center_changed', function() {
      secondChild.style['background-position'] = '0 0';
    });

    firstChild.addEventListener('click', function() {
      let imgX = '0';

      const animationInterval = setInterval(function() {
        imgX = imgX === '-18' ? '0' : '-18';
        secondChild.style['background-position'] = imgX + 'px 0';
      }, 500);

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function(position) {
          const latlng = new google.maps.LatLng(
            position.coords.latitude,
            position.coords.longitude
          );
          map.setCenter(latlng);
          clearInterval(animationInterval);
          secondChild.style['background-position'] = '-144px 0';
        });
      } else {
        clearInterval(animationInterval);
        secondChild.style['background-position'] = '0 0';
      }
    });

    return myLocationControlDiv;
  }

  viewDetails(id) {
    this.router.navigate([`/app/property/${id}`]);
  }

  initPin() {
    const pinSvg = document.querySelector('#map-pin').firstElementChild;
    this.pin = pinSvg.innerHTML || '';
  }

  generatePinUrl(color) {
    let coloredPin = this.pin;
    coloredPin = coloredPin.replace('pin-start-color', color.pinStart);
    coloredPin = coloredPin.replace('pin-end-color', color.pinEnd);
    coloredPin = coloredPin.replace('pin-circle-color', color.circle);
    coloredPin = coloredPin.replace('pin-stroke-color', color.pinStroke);
    return `data:image/svg+xml;charset=utf8,${encodeURIComponent(coloredPin)}`;
  }

  getPinUrl(pinStatus) {
    const pinColor =
      pinStatus === 'viewed' ? this.pinColors.viewed : this.pinColors.default;
    return this.generatePinUrl(pinColor);
  }

  setDefaultPin(markers, id = null) {
    if (markers && markers.length) {
      this.isMarksReady = true;
      markers.map(marker => {
        if (
          !marker.pinStatus ||
          (marker.pinStatus && marker.pinStatus === 'viewed') ||
          this.isForPropertyDetails
        ) {
          marker.pinStatus = this.isForPropertyDetails ? 'viewed' : 'default';
          marker.pinUrl = this.getPinUrl(marker.pinStatus);
        }
        if (id && marker.propertyId === id && marker.pinStatus !== 'viewed') {
          marker.pinStatus = 'viewed';
          marker.pinUrl = this.getPinUrl(marker.pinStatus);
        }
      });
    }
  }

  clickedMarker(markers, m, infoWindow) {
    this.setDefaultPin(markers, m);

    if (this.selectedInfoWindow) {
      this.selectedInfoWindow.close();
    }
    this.selectedInfoWindow = infoWindow;
  }
}
